import { combineReducers } from 'redux';
import auth from 'reducers/admin/auth';
import students from 'reducers/admin/students';
import schools from 'reducers/admin/schools';
import courses from 'reducers/admin/courses';
import batches from 'reducers/admin/batches';
import subjects from 'reducers/admin/subjects';
import schoolAdmins from 'reducers/admin/schoolAdmins';
import guardians from 'reducers/admin/guardians';
import employees from 'reducers/admin/employees';
import marks from 'reducers/admin/marks';
import config from 'reducers/admin/config';
import fees from 'reducers/admin/fees';
import transportFee from 'reducers/admin/transportFee';
import billing from 'reducers/admin/billing';
import activities from 'reducers/admin/activities';
import admissions from 'reducers/admin/admissions';

const combineReducer = combineReducers({
  auth,
  students,
  schools,
  courses,
  batches,
  subjects,
  schoolAdmins,
  guardians,
  employees,
  marks,
  config,
  fees,
  transportFee,
  billing,
  activities,
  admissions,
});

const rootReducer = (state, action) => {
  if (action.type === 'CLEAR_STORE') {
    state = undefined;
  }
  if (action.type === 'CLEAR_STORE_EXCEPT_AUTH_SCHOOL') {
    state = { auth: state && state.auth, schools: state && state.schools };
  }
  return combineReducer(state, action);
};

export default rootReducer;
